/**
 * Campo numerico dei test di misura: testo libero con la virgola dei
 * decimali e l'unità accanto, quando c'è. Lo usano il form del test e
 * l'anteprima; l'esecuzione ne ha uno per cella, con l'etichetta nascosta
 * perché la dice l'intestazione della colonna.
 */

import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from '@/components/ui/input-group';

export function CampoNumero({
  id,
  etichetta,
  unita,
  valore,
  onCambia,
  errore,
  etichettaNascosta = false,
  onKeyDown,
}: {
  id: string;
  etichetta: string;
  unita: string | null;
  valore: string;
  onCambia: (valore: string) => void;
  errore?: string;
  etichettaNascosta?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}) {
  const comune = {
    id,
    inputMode: 'decimal' as const,
    value: valore,
    'aria-invalid': Boolean(errore),
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => onCambia(e.target.value),
    onKeyDown,
  };
  return (
    <Field data-invalid={Boolean(errore)}>
      <FieldLabel htmlFor={id} className={etichettaNascosta ? 'sr-only' : undefined}>
        {etichetta}
      </FieldLabel>
      {unita ? (
        <InputGroup>
          <InputGroupInput {...comune} />
          <InputGroupAddon align="inline-end">
            <InputGroupText>{unita}</InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      ) : (
        <Input {...comune} />
      )}
      <FieldError>{errore}</FieldError>
    </Field>
  );
}
